import catalog from './pages.json';

export const SITE_URL = catalog.siteUrl;
export const SITE_NAME = catalog.siteName;
export const OG_IMAGE_PATH = catalog.ogImage;
export const OG_IMAGE_WIDTH = catalog.ogImageWidth;
export const OG_IMAGE_HEIGHT = catalog.ogImageHeight;
export const OG_IMAGE_ALT = catalog.ogImageAlt;
export const organizationJsonLd = catalog.organization;

export interface ISeoPage {
    title: string;
    description: string;
    canonicalPath: string;
    heading?: string;
    noindex?: boolean;
}

export const fullTitle = (title: string) => `${title} | ${SITE_NAME}`;

export const canonicalUrlFor = (path: string) =>
    `${SITE_URL}${path === '/' ? '/' : path}`;

export const ogImageUrl = `${SITE_URL}${OG_IMAGE_PATH}`;

export const normalizePath = (pathname: string) => {
    if (!pathname || pathname === '/') {
        return '/';
    }

    const withoutQuery = pathname.split('?')[0];
    const trimmed = withoutQuery.replace(/\/+$/, '');
    return trimmed === '' ? '/' : trimmed;
};

export const getSeoForPath = (pathname: string): ISeoPage => {
    const path = normalizePath(pathname);
    const pages = catalog.pages as Record<string, { title: string; description: string; heading?: string }>;

    if (pages[path]) {
        return { ...pages[path], canonicalPath: path };
    }

    if (path.startsWith('/jobs/') && path.length > 6) {
        return { ...catalog.jobOffer, canonicalPath: path };
    }

    return { ...catalog.notFound, canonicalPath: path, noindex: true };
};
